import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['filter', 'view']

  connect() {
    this.toggle()
  }

  toggle(event) {
    if (this.viewTarget.value == 'Tile' || this.viewTarget.value == 'Legacy') {
    console.log(this.viewTarget.value)
      for(let filter of this.filterTargets) {
        filter.style.display = 'none'
      }
    } else {
      for(let filter of this.filterTargets) {
        filter.style.display = 'flex'
      }
    }
  }
}
